import { ActionHeader, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useState } from "react";
import Table from "@/common/elements/Table";

const FlagDangerDetails = () =>{
      const [showFlagDangerDetails,setShowFlagDangerDetails] = useState(false);
            const clickFlagDangerDetails = () => {
                setShowFlagDangerDetails(true)
            }
            const flagDangerDetailsTable = {
                headers: [
                  { key: "flag", text: "Flag" },
                  { key: "summaryDescription", text: "Summary Description" },
                  { key: "relatedRecordSummary", text: "Related Record Summary" }
                  
                ],
                rows: [
                    { flag: "In Jail", summaryDescription: "Escape risk.", relatedRecordSummary:"SEIDL, LAUREN (#2300002). Arrested on 21-03-2023.", }, 
                   
                ]
              }
    return(
        <>
        <StyledGridRow justify={'space-between'}>
            
            <StyledGridCol>
              
            </StyledGridCol>
            <StyledGridCol>
              <Button>Delete</Button>
            </StyledGridCol>
          </StyledGridRow>

          

       <Table headers={flagDangerDetailsTable.headers} data={flagDangerDetailsTable.rows} style={{marginTop:"15px"}} />
        
        </>
    )
}
export default FlagDangerDetails;